import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_b34784ad-a649-4d8b-9d46-f4aa92c496c6/artifacts/59p6zsqu_NEMT%20LOGO%20Transparent%20%281%29.png"
              alt="Quality Transport Services"
              className="h-16 w-auto mb-4"
            />
            <p className="text-blue-100 text-sm leading-relaxed">
              Veteran-owned and family-operated Non-Emergency Medical Transportation
              serving Calhoun County and surrounding areas with safe, reliable, and
              respectful service.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/book-ride"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Book a Ride
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/partnerships"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Healthcare Partnerships
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Additional Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">Services & Tools</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/quick-quote"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Get Quick Quote
                </Link>
              </li>
              <li>
                <Link
                  to="/insurance-verification"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Verify Insurance
                </Link>
              </li>
              <li>
                <Link
                  to="/compliance"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Compliance & Certifications
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-blue-100 hover:text-amber-300 transition-colors duration-200"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-amber-400" />
                <span className="text-blue-100">(269) 248-3514</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-amber-400" />
                <span className="text-blue-100 text-sm">qualitytransportservices42@gmail.com</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-amber-400 mt-0.5" />
                <span className="text-blue-100 text-sm">
                  Serving Calhoun County<br />and surrounding areas
                </span>
              </div>
              <div className="flex items-start space-x-3">
                <Clock className="h-5 w-5 text-amber-400 mt-0.5" />
                <div className="text-blue-100 text-sm">
                  <div>Mon-Thu: 8:00am-5:00pm</div>
                  <div>Fri: 8:00am-4:00pm</div>
                  <div>Sat-Sun: 8:00am-12:00pm</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-800 mt-8 pt-8 text-center">
          <p className="text-blue-100 text-sm">
            © 2024 Quality Transport Services. All rights reserved. | Veteran-owned & Family-operated
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;